import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { useTranslation } from 'react-i18next';

const Breadcrumb: FC = () => {
  const { i18n } = useTranslation();
  const isKoreanLanguage = (lang: string) => lang === 'ko';
  const { selectMenu } = useSelector((state: RootState) => state.menu);
  const menuFirstStep =  isKoreanLanguage(i18n.language) ? selectMenu?.mainMenu?.info?.korName : selectMenu?.mainMenu?.info?.engName;
  const menuSecondStep =  isKoreanLanguage(i18n.language) ? selectMenu?.subMenu?.info?.korName : selectMenu?.subMenu?.info?.engName;


  return (
    <div className="breadcrumb-area">
      <ol>
        <li className="path home">Home</li>
        {
          selectMenu
            ? (
              <>
                <li className={`path`}>{menuFirstStep}</li>
                <li className={`path active`}>{menuSecondStep}</li>
              </>
            )
            : undefined
        }
      </ol>
    </div>
  )
}

export default Breadcrumb;